import { useState, useEffect } from "react";
import { capitalize } from "../utils/capitalize";
import { Option } from "../interface/interface";
import { getTagsByMeasurement } from "../../services/api";

export function useAreaTags() {
  const [areaOptions, setAreaOptions] = useState<Option[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<null | Error>(null);

  useEffect(() => {
    const fetchTags = async () => {
      setLoading(true);
      try {
        const response = await getTagsByMeasurement();
        const tags = response?.data || [];
        const options = tags.map((tag: string) => ({
          label: capitalize(tag),
          value: tag,
        }));
        setAreaOptions(options);
        setError(null);
      } catch (err) {
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    };

    fetchTags();
  }, []);

  return { areaOptions, loading, error };
}
